import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { catchError, Observable, tap, throwError } from 'rxjs';
import {
  CreateMerchantParams,
  DeleteMerchantByIdResponse,
  GetMerchantByIdResponse, GetMerchantRequestParams,
  GetMerchantResponse, UpdateMerchantRequestParams,
  MerchantData
} from '../../pages/merchants/merchants.interface';
import { environment } from '../../../environments/environment';
import { toQueryString } from '../../shared/helpers/helpers';

import { GetMerchantListResponse } from '../../interfaces/merchants.interface';

@Injectable({
  providedIn: 'root'
})
export class MerchantsService {
  private apiUrl = environment.api + '/merchants';
  private tokenKey = environment.accessTokenName;

  constructor(private http: HttpClient) {}

  getMerchants(): Observable<GetMerchantListResponse> {
    return this.http.get<GetMerchantListResponse>(this.apiUrl).pipe(
      tap(response => this.handleResponse(response)),
      catchError(error => this.handleError(error))
    );
  }

  private handleResponse<T>(response: T & { code: number; message?: string }): T {
    if (response.code !== 0) {
      throw new Error(response.message);
    }
    return response;
  }

  private handleError(error: any): Observable<never> {
    console.error('API Error:', error);
    return throwError(() => new Error(error.error?.message || 'Error'));
  }

  getMerchantService(requestParams: GetMerchantRequestParams): Observable<GetMerchantResponse> {
    const url = this.apiUrl + '?' + toQueryString(requestParams);
    return this.http.get<GetMerchantResponse>(url).pipe(
      tap(response => this.handleResponse(response)), // ✅ Pakai arrow function
      catchError(error => this.handleError(error))   // ✅ Pakai arrow function
    );
  }

  getMerchantById(id: string): Observable<GetMerchantByIdResponse> {
    return this.http.get<GetMerchantByIdResponse>(`${this.apiUrl}/${id}`).pipe(
      tap(response => this.handleResponse(response)),
      catchError(error => this.handleError(error))
    );
  }

  deleteMerchantById(id: string): Observable<DeleteMerchantByIdResponse> {
    return this.http.delete<DeleteMerchantByIdResponse>(`${this.apiUrl}/${id}`).pipe(
      tap(response => this.handleResponse(response)),
      catchError(error => this.handleError(error))
    );
  }

  createMerchant(merchantData: CreateMerchantParams): Observable<GetMerchantByIdResponse> {
    return this.http.post<GetMerchantByIdResponse>(this.apiUrl, merchantData).pipe(
      tap(response => this.handleResponse(response)),
      catchError(error => this.handleError(error))
    );
  }

  updateMerchant(id: string, merchantData: UpdateMerchantRequestParams): Observable<GetMerchantByIdResponse> {
    return this.http.put<GetMerchantByIdResponse>(`${this.apiUrl}/${id}`, merchantData).pipe(
      tap(response => this.handleResponse(response)),
      catchError(error => this.handleError(error))
    );
  }
}
